<div class="seguimiento-container">
  <div class="page-header">
    <div class="page-title-container">
      <div class="page-icon"><i class="fi fi-rr-shield-check"></i></div>
      <div>
        <h1>Seguimiento de planes contratados</h1>
        <p>Revisa el estado de los planes contratados por convenio y consulta sus cambios dentro del período seleccionado.</p>
      </div>
    </div>

    <div class="header-actions">
      <button type="button" class="btn btn-outline-primary btn-exportar"
              [disabled]="!suscripcionesFiltradas.length"
              (click)="exportarCSV()">
        <i class="fi fi-rr-download"></i>
        Exportar
      </button>

      <button type="button" class="btn btn-primary btn-nueva-inscripcion"
              routerLink="/inscripcion-convenio-ejecutivo">
        <i class="fi fi-rr-plus"></i>
        Nueva inscripción asistida
      </button>
    </div>
  </div>

  <div class="card filtro-card">
    <div class="filtro-row">
      <div class="filtro-label">
        <i class="fi fi-rr-building"></i>
        <span>CLIENTE</span>
      </div>

      <div class="filtro-content">
        <select class="form-control cliente-select"
                [(ngModel)]="clienteSeleccionado"
                (change)="onClienteChange()"
                [disabled]="cargandoClientes || clientes.length === 0">
          <option [ngValue]="null" disabled>
            {{ cargandoClientes ? 'Cargando clientes...' : 'Seleccione un cliente' }}
          </option>
          <option *ngFor="let cliente of clientes" [ngValue]="cliente.cus_id">
            {{ cliente.cus_name }}
          </option>
        </select>
      </div>
    </div>

    <div class="separator"></div>

    <div class="filtro-row periodo-row">
      <div class="filtro-label">
        <i class="fi fi-rr-calendar"></i>
        <span>PERIODO</span>
      </div>

      <div class="periodos-container">
        <button *ngFor="let periodo of periodos"
                type="button"
                class="periodo-chip"
                [class.active]="periodoSeleccionado === periodo.id"
                (click)="seleccionarPeriodo(periodo.id)">
          {{ periodo.nombre }}
        </button>
      </div>
    </div>

    <div class="fechas-row">
      <div class="fecha-field">
        <label>DESDE</label>
        <input type="date"
               class="form-control"
               [(ngModel)]="fechaDesdeTemporal"
               (change)="onFechaChange()"
               [disabled]="periodoSeleccionado !== 'custom'">
      </div>

      <div class="fecha-separator">–</div>

      <div class="fecha-field">
        <label>HASTA</label>
        <input type="date"
               class="form-control"
               [(ngModel)]="fechaHastaTemporal"
               (change)="onFechaChange()"
               [disabled]="periodoSeleccionado !== 'custom'">
      </div>

      <button type="button"
              class="btn btn-aplicar"
              [class.pending]="fechasPendientes"
              [disabled]="periodoSeleccionado !== 'custom'"
              (click)="aplicarFechas()">
        Aplicar
      </button>

      <span *ngIf="periodoSeleccionado === 'custom' && fechasPendientes"
            class="cambios-pendientes">
        <i class="fi fi-rr-clock"></i>
        Cambios sin aplicar
      </span>
    </div>

    <div *ngIf="resumenPeriodo" class="periodo-resumen">
      <i class="fi fi-rr-check"></i>
      <span>{{ resumenPeriodo }}</span>
    </div>

    <div *ngIf="mensajeError" class="alert alert-danger mt-3 mb-0">
      {{ mensajeError }}
    </div>

    <div class="buscar-row">
      <button type="button"
              class="btn btn-primary btn-ver-seguimiento"
              [disabled]="cargandoClientes || cargandoSeguimiento || !clienteSeleccionado"
              (click)="verSeguimiento()">
        <i *ngIf="!cargandoSeguimiento" class="fi fi-rr-search"></i>
        <span *ngIf="cargandoSeguimiento" class="spinner-border spinner-border-sm mr-1"></span>
        {{ cargandoSeguimiento ? 'Cargando...' : 'Ver seguimiento' }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="seguimientoCargado">

    <div class="kpis-container">
      <div class="kpi-card">
        <div class="kpi-label">
          <i class="fi fi-rr-check"></i>
          Planes activos
        </div>
        <div class="kpi-value verde">{{ totalActivos }}</div>
        <div class="kpi-description">
          {{ periodoSeleccionado === 'all' ? 'en todo el histórico' : 'en el período seleccionado' }}
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-label">
          <i class="fi fi-rr-pause"></i>
          Suspendidos
        </div>
        <div class="kpi-value">{{ totalSuspendidos }}</div>
        <div class="kpi-description">
          {{ periodoSeleccionado === 'all' ? 'en todo el histórico' : 'en el período seleccionado' }}
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-label">
          <i class="fi fi-rr-cross-circle"></i>
          Cancelados
        </div>
        <div class="kpi-value rojo">{{ totalCancelados }}</div>
        <div class="kpi-description">
          {{ periodoSeleccionado === 'all' ? 'en todo el histórico' : 'en el período seleccionado' }}
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-label">
          <i class="fi fi-rr-percentage"></i>
          Tasa de cancelación
        </div>
        <div class="kpi-value rojo">{{ tasaCancelacion }}%</div>
        <div class="kpi-description">del total en el rango</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-label">
          <i class="fi fi-rr-clock-three"></i>
          Titulares sin actividad
        </div>
        <div class="kpi-value rojo">
          {{ tieneDatosActividad ? totalTitularesSinActividad : '—' }}
        </div>
        <div class="kpi-description">
          {{ tieneDatosActividad ? 'Nunca han ingresado a la plataforma' : 'Dato aún no disponible' }}
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <button type="button" class="tab-btn"
              [class.active]="tabSeleccionado === 'TODOS'"
              (click)="seleccionarTab('TODOS')">
        Todos
      </button>

      <button type="button" class="tab-btn"
              [class.active]="tabSeleccionado === 'ACTIVO'"
              (click)="seleccionarTab('ACTIVO')">
        Activos
      </button>

      <button type="button" class="tab-btn"
              [class.active]="tabSeleccionado === 'SUSPENDIDO'"
              (click)="seleccionarTab('SUSPENDIDO')">
        Suspendidos
      </button>

      <button type="button" class="tab-btn"
              [class.active]="tabSeleccionado === 'CANCELADO'"
              (click)="seleccionarTab('CANCELADO')">
        Cancelados
      </button>
    </div>

    <div class="filtros-tabla">
      <div class="search-box">
        <i class="fi fi-rr-search"></i>
        <input type="text"
               class="form-control"
               placeholder="Buscar por nombre o RUT..."
               [(ngModel)]="busqueda"
               (ngModelChange)="onFiltroChange()">
      </div>

      <select class="form-control filtro-select"
              [(ngModel)]="filtroMotivo"
              (change)="onFiltroChange()">
        <option value="">Todos los motivos</option>
        <option *ngFor="let motivo of motivosDisponibles" [value]="motivo">
          {{ motivo }}
        </option>
      </select>

      <select class="form-control filtro-select"
              [(ngModel)]="filtroPlan"
              (change)="onFiltroChange()">
        <option value="">Todos los planes</option>
        <option *ngFor="let plan of planesDisponibles" [value]="plan.id">
          {{ plan.nombre }}
        </option>
      </select>

      <select class="form-control filtro-select"
              [(ngModel)]="filtroEjecutivo"
              (change)="onFiltroChange()">
        <option value="">Todos los ejecutivos</option>
        <option *ngFor="let ejecutivo of ejecutivosDisponibles" [value]="ejecutivo">
          {{ ejecutivo }}
        </option>
      </select>
    </div>

    <div class="table-card">
      <div class="table-responsive">
        <table class="tabla-planes">
          <thead>
            <tr>
              <th>TITULAR</th>
              <th>PLAN</th>
              <th>ESTADO</th>
              <th>MOTIVO</th>
              <th>FECHA DE CONTRATACIÓN</th>
              <th class="sortable" (click)="toggleOrdenFecha()">
                CAMBIO DE ESTADO
                <span>{{ ordenFechaAsc ? '▲' : '▼' }}</span>
              </th>
              <th>EJECUTIVO</th>
              <th>CONTACTO</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of suscripcionesPaginadas">
              <td>
                <div class="titular-nombre">{{ item.titular_nombre_completo || '—' }}</div>
                <div class="titular-rut">{{ formatearRut(item.use_rut) }}</div>
              </td>

              <td>
                <div class="plan-table-name">{{ item.plan_nombre || '—' }}</div>
              </td>

              <td>
                <span class="status-pill" [ngClass]="getEstadoClase(item)">
                  {{ getEstado(item) }}
                </span>
              </td>

              <td>
                <span *ngIf="getMotivo(item) !== '—'"
                      class="motivo-pill"
                      [ngClass]="getMotivoClase(item)">
                  {{ getMotivo(item) }}
                </span>
                <span *ngIf="getMotivo(item) === '—'">—</span>
              </td>

              <td>{{ formatearFechaVista(item.fecha_contratacion) }}</td>
              <td>{{ formatearFechaVista(item.fecha_actualizacion) }}</td>

              <td>
                <div class="ejecutivo-table">
                  {{ getEjecutivo(item) }}
                </div>
              </td>

              <td>
                <div class="contact-actions">
                  <a *ngIf="item.telefono"
                     class="icon-btn"
                     [href]="'tel:' + item.telefono"
                     title="Llamar">
                    <i class="fi fi-rr-headset"></i>
                  </a>

                  <a *ngIf="item.use_email"
                     class="icon-btn"
                     [href]="'mailto:' + item.use_email"
                     title="Enviar correo">
                    <i class="fi fi-rr-envelope"></i>
                  </a>
                </div>
              </td>

              <td>
                <button type="button"
                        class="icon-btn"
                        title="Ver detalle"
                        (click)="abrirDetalle(item)">
                  <i class="fi fi-rr-eye"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="suscripcionesFiltradas.length === 0">
              <td colspan="9" class="sin-resultados">
                <i class="fi fi-rr-search"></i>
                <span>No se encontraron planes que coincidan con los filtros.</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer">
        <div class="resultado-texto">
          {{ suscripcionesFiltradas.length }} de {{ totalSuscripciones }} planes ·
          {{ clienteNombreSeleccionado }}
          <span *ngIf="periodoSeleccionado !== 'all'">
            · {{ nombrePeriodoSeleccionado }}
          </span>
        </div>

        <div class="pagination" *ngIf="suscripcionesFiltradas.length > 0">
          <button type="button"
                  class="page-btn page-text"
                  [disabled]="paginaActual === 1"
                  (click)="irPagina(paginaActual - 1)">
            ‹ Anterior
          </button>

          <button *ngFor="let pagina of paginasVisibles"
                  type="button"
                  class="page-btn"
                  [class.active]="pagina === paginaActual"
                  (click)="irPagina(pagina)">
            {{ pagina }}
          </button>

          <button type="button"
                  class="page-btn page-text"
                  [disabled]="paginaActual === totalPaginas"
                  (click)="irPagina(paginaActual + 1)">
            Siguiente ›
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- DRAWER -->
<div *ngIf="drawerAbierto"
     class="drawer-overlay"
     (click)="cerrarDetalle()">

  <aside class="detalle-drawer"
         (click)="$event.stopPropagation()"
         *ngIf="suscripcionSeleccionada">

    <div class="drawer-header">
      <div>
        <h2>{{ suscripcionSeleccionada.titular_nombre_completo }}</h2>
        <p>
          {{ formatearRut(suscripcionSeleccionada.use_rut) }}
          ·
          {{ suscripcionSeleccionada.plan_nombre }}
        </p>
      </div>

      <button type="button"
              class="drawer-close"
              (click)="cerrarDetalle()">
        <i class="fi fi-rr-cross-small"></i>
      </button>
    </div>

    <div class="drawer-body">

      <section class="detalle-card">
        <h3>ESTADO</h3>

        <div class="estado-grid">
          <div class="info-item">
            <span class="info-label">Estado</span>
            <span class="status-pill"
                  [ngClass]="getEstadoClase(suscripcionSeleccionada)">
              {{ getEstado(suscripcionSeleccionada) }}
            </span>
          </div>

          <div class="info-item">
            <span class="info-label">Motivo</span>

            <span *ngIf="getMotivo(suscripcionSeleccionada) !== '—'"
                  class="motivo-pill"
                  [ngClass]="getMotivoClase(suscripcionSeleccionada)">
              {{ getMotivo(suscripcionSeleccionada) }}
            </span>

            <span *ngIf="getMotivo(suscripcionSeleccionada) === '—'">—</span>
          </div>
        </div>

        <p class="estado-explicacion"
           *ngIf="getEstado(suscripcionSeleccionada) === 'Suspendido' && getMotivo(suscripcionSeleccionada) === 'No pago'">
          Regla de no pago: el plan queda suspendido al presentar cuotas impagas y puede ser cancelado de acuerdo con las reglas vigentes de la suscripción.
        </p>
      </section>

      <section class="detalle-card">
        <h3>INFORMACIÓN DEL PLAN</h3>

        <div class="plan-info-grid">
          <div class="info-item">
            <span class="info-label">Plan</span>
            <strong>{{ suscripcionSeleccionada.plan_nombre || '—' }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Valor mensual</span>
            <strong>{{ formatearMonto(getValorMensual(suscripcionSeleccionada)) }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Cliente asociado</span>
            <strong>{{ clienteNombreSeleccionado || '—' }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Tipo de plan</span>
            <strong>{{ getTipoPlan(suscripcionSeleccionada) }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Tipo de contratación</span>
            <strong>{{ getTipoContratacion(suscripcionSeleccionada) }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Fecha de contratación</span>
            <strong>{{ formatearFechaVista(suscripcionSeleccionada.fecha_contratacion) }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Fecha término de vigencia</span>
            <strong>
              {{ formatearFechaVista(suscripcionSeleccionada.fecha_termino_vigencia) }}
            </strong>
            <small *ngIf="suscripcionSeleccionada.fecha_termino_vigencia">
              renovación automática
            </small>
          </div>

          <div class="info-item">
            <span class="info-label">Beneficiarios contratados</span>
            <strong>{{ suscripcionSeleccionada.cantidad_beneficiarios || 0 }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Ejecutivo que contrató</span>
            <strong>{{ getEjecutivo(suscripcionSeleccionada) }}</strong>
          </div>

          <div class="info-item">
            <span class="info-label">Cambio de estado</span>
            <strong>{{ formatearFechaVista(suscripcionSeleccionada.fecha_actualizacion) }}</strong>
          </div>
        </div>
      </section>

      <section class="detalle-card">
        <h3>CONTACTO DEL TITULAR</h3>

        <p class="detalle-subtitle">
          Comunícate tú mismo con el titular para gestionar la retención.
        </p>

        <a *ngIf="suscripcionSeleccionada.telefono"
           class="contact-row"
           [href]="'tel:' + suscripcionSeleccionada.telefono">
          <i class="fi fi-rr-headset"></i>
          <strong>{{ suscripcionSeleccionada.telefono }}</strong>
        </a>

        <a *ngIf="suscripcionSeleccionada.use_email"
           class="contact-row"
           [href]="'mailto:' + suscripcionSeleccionada.use_email">
          <i class="fi fi-rr-envelope"></i>
          <strong>{{ suscripcionSeleccionada.use_email }}</strong>
        </a>
      </section>

      <section class="detalle-card">
        <h3>TITULAR Y BENEFICIARIOS</h3>

        <p class="detalle-subtitle">
          Acceso a la plataforma de cada persona asociada al plan.
        </p>

        <div class="personas-table-wrapper">
          <table class="personas-table">
            <thead>
              <tr>
                <th>NOMBRE</th>
                <th>TIPO</th>
                <th>ACCESO</th>
                <th>ÚLTIMA C.</th>
                <th>CONTACTO</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let persona of getPersonasPlan(suscripcionSeleccionada)">
                <td>
                  <strong>{{ persona.nombre_completo || '—' }}</strong>
                  <small>{{ formatearRut(persona.rut) }}</small>
                </td>

                <td>{{ persona.tipo }}</td>

                <td>
                  <span class="acceso-pill"
                        [ngClass]="getAccesoClase(persona)">
                    {{ getAccesoPersona(persona) }}
                  </span>
                </td>

                <td>{{ getUltimaConsulta(persona) }}</td>

                <td>{{ getContactoPersona(persona) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="detalle-card">
        <h3>ESPECIALIDADES Y CANTIDAD DE CONSULTAS DEL PLAN</h3>

        <p class="detalle-subtitle">
          Tope de consultas anuales por especialidad para el titular.
        </p>

        <div class="especialidades-list">
          <div class="especialidad-row"
               *ngFor="let especialidad of getEspecialidades(suscripcionSeleccionada)">

            <div class="especialidad-name">
              <i class="fi fi-rr-stethoscope"></i>
              <strong>{{ especialidad.spe_name }}</strong>
            </div>

            <strong class="especialidad-cantidad">
              {{ getCantidadConsultasEspecialidad(especialidad) }}
            </strong>
          </div>

          <div class="sin-especialidades"
               *ngIf="getEspecialidades(suscripcionSeleccionada).length === 0">
            No existen especialidades configuradas para este plan.
          </div>
        </div>
      </section>

      <section class="detalle-card">
        <h3>CONSIDERACIONES DEL PLAN</h3>

        <p class="consideraciones">
          {{ suscripcionSeleccionada.plan_descripcion || 'No existen consideraciones registradas para este plan.' }}
        </p>
      </section>

      <section class="detalle-card">
        <h3>HISTORIAL</h3>

        <div class="historial">
          <div class="historial-item"
               *ngFor="let historial of getHistorialVisual(suscripcionSeleccionada)">

            <div class="timeline-column">
              <span class="timeline-dot"
                    [class.activo]="historial.tipo === 'activo'"
                    [class.suspendido]="historial.tipo === 'suspendido'"
                    [class.cancelado]="historial.tipo === 'cancelado'">
              </span>
              <span class="timeline-line"></span>
            </div>

            <div class="historial-content">
              <strong>{{ historial.titulo }}</strong>
              <span>{{ formatearFechaVista(historial.fecha) }}</span>
            </div>
          </div>

          <div class="sin-historial"
               *ngIf="getHistorialVisual(suscripcionSeleccionada).length === 0">
            No hay historial disponible.
          </div>
        </div>
      </section>

    </div>
  </aside>
</div>